export default __webpack_public_path__ + "static/iconLot-white-54dbaae72643b2055584fc1c96ec7dc0.svg";